export { TextInput } from './TextInput'
export type { TextInputProps } from './TextInput'
